import { Inertia } from "@inertiajs/inertia";

import { Trans } from "../utils/i18n";
import { hasProducts } from "./orderEntryEnfore";

export const shopNiuB2BConfig = {
    "sizes": {
        "forth": 3,
        "third": 4,
        "half": 6,
        "full": 12
    },
    "enableStepper": true,
    "heading": <Trans i18nKey="orderEntry.basicData">Basic data</Trans>,
    "defaultValues": {
        "private_or_company": "private",
    },
    "groups": [
        {
            "heading": <Trans i18nKey="orderEntry.productSelection">Product selection</Trans>,
            "description": <Trans i18nKey="orderEntry.productSelection.description"></Trans>,
            "id": "product_selection",
            "fields": [
                {
                    "size": "full",
                    "component": "callback",
                    "callback": (values) => <>
                        <h3 className={'mt-9'} style={{ marginBottom: 0 }}><Trans i18nKey={'orderEntry.model.pleaseSelect'}>Please select your model</Trans></h3>
                    </>,
                },
                {
                    "size": "full",
                    "component": "productconfig",
                    "isOrderable": false,
                    "isForSales": true,
                },
            ],
            "noNextButton": true,
        },
    ],
    "actions": [
        {
            "fields": [
                {
                    "text": <Trans i18nKey="shoppingCart.goToCheckout">Complete Checkout</Trans>,
                    "size": "half",
                    "component": "button",
                    "color": "secondary",
                    "onClick": () => {
                        Inertia.visit(route('partsshop.checkout'));
                    },
                    "conditionFunction": (values, orderEntryState) => {
                        return hasProducts(values.products);
                    }
                }
            ]
        }
    ]
}
